import { Collapse, List } from '@material-ui/core'
import { OpenInNew } from '@mui/icons-material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useState } from 'react'
import { openInNewTab } from '../../../utils'
import { useStyles } from '../../styles'
import Tooltip from '@mui/material/Tooltip'
import useLogout from '../../../hooks/useLogout'
import { useNavigate } from 'react-router'

export const Item = ({
  item,
  selectedItem,
  setSelectedItem,
  handleDrawerToggle,
}) => {
  const logout = useLogout()
  const navigate = useNavigate()
  const base_url = window.location.origin
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [openTooltip, setOpenTooltip] = useState(false)

  const handleClose = () => {
    setOpenTooltip(false)
  }
  const signOut = async () => {
    await logout()
    navigate('/ext_login')
  }

  const handleOpen = (e) => {
    if (item?.tooltip) {
      setOpenTooltip(true)
    }
  }
  const handleClick = (currentItem) => {
    // CHECK IF BUTTON LOGOUT
    if (currentItem.id == 'Déconnexion') {
      signOut()
    }
    // CHECK IF HAS NESTED ITEMS
    if (currentItem?.nestedItems?.length) {
      setOpen(!open)
    } else {
      // CHECK IF MENU ITEM IS REDIRECT URL
      if (currentItem.toItem) {
        setSelectedItem(currentItem.toItem)
        return
      }
      if (currentItem.toUrl) {
        openInNewTab(currentItem.toUrl)
      } else {
        setSelectedItem(currentItem)
      }
      handleDrawerToggle()
    }
  }
  const handleIcon = (icon) => {
    if (icon == 'Default') {
      return <OpenInNew />
    } else if (icon) {
      return <img src={item.icon} width="25px" />
    } else {
      return null
    }
  }
  return (
    <>
      <Tooltip
        title={item.tooltip}
        open={openTooltip}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <ListItemButton
          onClick={(e) => {
            e.preventDefault()
            handleClick(item)
          }}
          style={
            item.id == selectedItem?.id
              ? {
                  textDecoration: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                }
              : {}
          }
          disabled={item?.disabled}
        >
          <ListItemIcon className={classes.icon}>
            {handleIcon(item.icon)}
          </ListItemIcon>
          <ListItemText primary={item.label} />
          {item.nestedItems.length ? (
            <>{open ? <ExpandLess /> : <ExpandMore />}</>
          ) : (
            <></>
          )}
        </ListItemButton>
      </Tooltip>
      {item.nestedItems.length ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.nestedItems.map((it) => {
              if (it.hide) {
                return null
              }
              return (
                <ListItemButton
                  disabled={it?.disabled}
                  sx={{ pl: 4 }}
                  style={
                    it.id == selectedItem?.id
                      ? {
                          textDecoration: 'none',
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        }
                      : {}
                  }
                  onClick={(e) => {
                    e.preventDefault()
                    handleClick(it)
                  }}
                >
                  <ListItemText primary={it.label} />
                </ListItemButton>
              )
            })}
          </List>
        </Collapse>
      ) : (
        <></>
      )}
    </>
  )
}
export default Item
